import script from "./VirusCareListModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VirusCareListModalContent.vue?vue&type=script&setup=true&lang=js"

import "./VirusCareListModalContent.vue?vue&type=style&index=0&id=3a167863&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a167863"]])

export default __exports__